import { Component, ViewChild } from '@angular/core';
import { ContractsCommonService } from '../../service/contract-creation/contracts-common.service';
import { Subscription } from 'rxjs';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-port-info',
  templateUrl: './port-info.component.html',
  styleUrls: ['./port-info.component.scss'],
  standalone: false
})
export class PortInfoComponent {
  @ViewChild('portTable') portTable!: Table;

  visible: boolean = false;
  portsDetails: any;
  searchTerm: string = '';
  private subscription: Subscription = new Subscription();
  constructor(
    private contractCommonService: ContractsCommonService,
    private messageService: MessageService
  ) {
    const cachedPorts = this.contractCommonService.getPortUnlocSync();
    if (cachedPorts) {
      this.portsDetails = cachedPorts;
    } else {
      this.subscription.add(
        this.contractCommonService.portUnloc$.subscribe((response: any) => {
          if (response) {
            this.portsDetails = response;
          }
        })
      );
      this.subscription.add(
        this.contractCommonService.getAllPorts().subscribe({
          next: (response: any) => {
            if (response && response.data) {
              this.portsDetails = response.data;
            }
          },
          error: (error) => {
            console.error('Error fetching ports:', error);
          }
        })
      );
    }
  }

  copyToClipboard(value: string): void {
    navigator.clipboard.writeText(value).then(() => {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Copied to clipboard: ' + value
      });
    }).catch(err => {
      console.error('Error copying text: ', err);
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to copy text.'
      });
    });
  }

  downloadTableData(): void {
    const csvData = this.convertToCSV(this.portsDetails);
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'port_details.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  private convertToCSV(data: any[]): string {
    if (!data || !data.length) {
      return '';
    }
    const headers = ['Port Name', 'Port UNLOC'];
    const rows = data.map(row => [
      this.escapeCSVValue(row.portName),
      this.escapeCSVValue(row.portUnloc)
    ]);
    const csvRows = rows.map(row => row.join(','));
    return [headers.join(','), ...csvRows].join('\n');
  }

  private escapeCSVValue(value: string): string {
    if (value === null || value === undefined) {
      return '';
    }
    if (value.includes(',') || value.includes('"') || value.includes('\n')) {
      return `"${value.replace(/"/g, '""')}"`;
    }
    return value;
  }

  resetFilters(): void {
    this.searchTerm = '';
    if (this.portTable) {
      this.portTable.clear();
      this.portTable.filterGlobal(this.searchTerm, 'contains');
      this.portTable.reset();
      this.portTable.rows = 10;
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}